import React from "react";

class SettingsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <div id="modal-settings" className="modal-bg display-none" data-modalid="modal-settings" onClick={this.props.closeButton}>
                <div className="modal-container modal-settings" onClick={this.props.stopPropagation}>
                    <div className="modal-content">
                        <button className="icon-button modal-close-button" data-modalid="modal-settings" onClick={this.props.closeButton}>
                            <svg enableBackground="new 0 0 256 256" height="256px" id="Layer_1" version="1.1" viewBox="0 0 256 256" width="256px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
                        </button>
                        <h2>Settings</h2>
                        <hr />
                        <form>
                            <h3>Graphics:</h3>
                            <div className="graphics-flex">
                                <div className="graphics-radio-container">
                                    <input type="radio" id="settings-graphics-low" className="graphics-radio" name="graphics" value="low" /><label htmlFor="settings-graphics-low">Low</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="settings-graphics-medium" className="graphics-radio" name="graphics" value="medium" /><label htmlFor="settings-graphics-medium">Medium</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="settings-graphics-high" className="graphics-radio" name="graphics" value="high" defaultChecked /><label htmlFor="settings-graphics-high">High</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="settings-graphics-veryhigh" className="graphics-radio" name="graphics" value="veryhigh" /><label htmlFor="settings-graphics-veryhigh">Very High</label>
                                </div>
                                <div className="graphics-radio-container">
                                    <input type="radio" id="settings-graphics-ultra" className="graphics-radio" name="graphics" value="ultra" /><label htmlFor="settings-graphics-ultra">Ultra</label>
                                </div>
                            </div>
                            <sub>Higher graphics will use more data and impact performance if you are playing on a mobile device.</sub>
                            <br />
                            <br />

                            <hr />

                            <h3>Cookies</h3>
                            <input type="checkbox" id="accept-cookies" name="cookies" /><label htmlFor="accept-cookies">Accept cookies</label>
                            <br />
                            <sub>Cookies are only used to save your graphics settings.</sub>
                            <br />
                            <br />
                            <hr />
                            <br />

                            <input type="submit" value="Apply" className="button" data-modalid="modal-settings" onClick={this.props.setSettings} />
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default SettingsModal;